@if (title(); as title) {
<div libFlexColumn>
	<div class="ui-chip" [class.active]="isActive()">
		{{ title }}
	</div>
</div>
}
